import { errorText } from '@design-system/components/input/input.css';
import {
  Typography,
  TypographyProps,
} from '@design-system/components/typography/typography';
import { space } from '@design-system/tokens';
import { InputLabel } from '@mui/material';
import React from 'react';

export type LabelProps = {
  error?: string | undefined;
  id?: string;
  required?: boolean;
  content?: string;
  style?: React.CSSProperties;
};
export const Label = (p: LabelProps) => (
  <InputLabel
    id={p.id}
    required={p.required}
    error={p.error !== undefined && p.error !== ''}
    style={{ fontSize: '14px', fontWeight: 600, marginTop: '1em', ...p.style }}
  >
    {p.content}
  </InputLabel>
);

export const ErrorMessage = (p: {
  content?: string | React.ReactNode;
  size?: TypographyProps['size'];
}) =>
  p.content ? (
    <Typography variant="body" size={p.size || 'small'} className={errorText}>
      {p.content || null}
    </Typography>
  ) : null;
